export default __webpack_public_path__ + "static/media/addFeeWhite.337982b2.svg";